import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DEFAULT_LANG: InjectionToken<string> = new InjectionToken<string>('defaultLang', {
  factory: () => 'en'
});
